import React, { ReactNode } from "react"

import { InputAdornment } from '@mui/material'

import { StyledTextField, StyledTextFieldProps } from "./styled"

type TextFieldProps = StyledTextFieldProps & {
  endAdornment?: ReactNode
  startAdornment?: ReactNode
}

export const TextField = ({ hiddenLabel = true, placeholder, variant = "filled", ...props}: TextFieldProps) => {
  const { label, required } = props

  // TODO: Remove inconsistences of passing adornments in props. Choose only one (ether directly or within InputProps).
  // Otherwise it may lead to unexpected bugs;
  const startAdornment = props.startAdornment || props.InputProps?.startAdornment
  const endAdornment = props.endAdornment || props.InputProps?.endAdornment

  let renderPlaceholder = placeholder || ""

  if (renderPlaceholder && required && (hiddenLabel || !label)) renderPlaceholder = `${renderPlaceholder}*`

  return (
    <StyledTextField
      autoComplete="off"
      hiddenLabel={hiddenLabel}
      placeholder={renderPlaceholder}
      variant={variant}
      InputProps={{
        ...(props.InputProps || {}),
        startAdornment: <InputAdornment position={"start"}>{startAdornment}</InputAdornment>,
        endAdornment: <InputAdornment position={"end"}>{endAdornment}</InputAdornment>,
      }}
      {...props}
    />
  )
}
